import { useLocation } from "react-router-dom";
import styled from "styled-components"
import config from "../config";
import NavMenu from "./NavMenu";

const SideMenu = () => {
	const pathname = useLocation().pathname;
	let thisConfig
	if (pathname.indexOf('/f0') === 0) {
		thisConfig = config.navMenus0;
	} else if (pathname.indexOf('/f1') === 0) {
		thisConfig = config.navMenus1;
	}
	return (
		<SideMenuWrapper>
			{thisConfig.map((navMenuConfig, index) => {
				return (<NavMenu key={index} pathname={pathname} navMenuConfig={navMenuConfig}></NavMenu>);
			})}
		</SideMenuWrapper>
	);
}

export default SideMenu;

const SideMenuWrapper = styled.div`
        width: 200px;
      min-width: 200px;
      height: 100%;
      overflow-y: scroll;
    `;